module.exports = __webpack_public_path__ + "img/SES_4069003210.b7089b53.jpg";